import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import './sentry';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './locale/i18next.config';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
